import { type FC, type ReactNode } from 'react'

import { AccordionSummary } from 'base-ui'

type FooterBannerSectionHeaderProps = {
  headerText: ReactNode
}

/**
 * A reusable component for rendering a responsive header section.
 * Displays an interactive AccordionSummary on mobile and a non-interactive span on tablet/desktop.
 */
export const FooterBannerSectionHeader: FC<FooterBannerSectionHeaderProps> = ({
  headerText,
}) => {
  return (
    <>
      <AccordionSummary className="tablet:hidden">
        {headerText}
      </AccordionSummary>
      <span className="mb-3.5 hidden text-s font-medium tablet:block">
        {headerText}
      </span>
    </>
  )
}
